import React from "react";
import {
  FormControlLabel,
  Button,
  Checkbox,
  FormGroup,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

function MemberShip(props) {
  const classes = props.useStyles();
  const onView = (e) => {
    e.preventDefault();
    window.location.href = "http://service.sw.co.kr/policy_special/policy.php";
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          inputRef={props.memberShipRef}
          control={
            <Checkbox
              checked={props.memberShip}
              onChange={(e) => {
                props.onChangeMemberShip(e.target.checked);
              }}
              name="memberShip"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [필수]멤버십 이용약관 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
    </>
  );
}
export default MemberShip;
